const historyObject = require("history").createBrowserHistory;

export default historyObject;
